/** Share only in-flight reads. Settled reads are cached by the query layer,
 * so explicit refreshes and mutation reconciliation still reach the service. */
const pendingReads = new Map<string, Promise<unknown>>();
export function sharePendingRead<T>(key: string, load: () => Promise<T>): Promise<T> {
  const existing = pendingReads.get(key);
  if (existing) return existing as Promise<T>;
  const request = Promise.resolve().then(load).finally(() => {
    if (pendingReads.get(key) === request) pendingReads.delete(key);
  });
  pendingReads.set(key, request);
  return request;
}
export const readKey = (resource: string, input: Record<string, unknown>) => JSON.stringify([
  resource,
  Object.keys(input).sort().filter(key => input[key] !== undefined).map(key => [key, input[key]]),
]);
export const canonicalIds = (ids: string[]) => [...new Set(ids.filter(Boolean))].sort();
